<template>
  
    <div class="no-data">
        {{$t(text)}}
        <slot name="default" />
    </div>

</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: 'NO_DATA'
        }
    }
}
</script>

<style scoped>

.no-data {
    background-color: var(--color-background-default-tertiary);
    color: var(--color-text-default-default);
    padding: 16px;
    border-radius: 8px;
    box-sizing: border-box;
    letter-spacing: .64px;
}
</style>